import { createAddressHttpRepository } from '@src/main/modules/messages/infrastructure/repository/AddressHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

export const deleteAddressUseCase = async (
  id: string,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createAddressHttpRepository(tokenProvider);
  await repository.delete(id);
};
